import { apiSlice } from "redux/api/apiSlice";

export const editorImages = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    EditorImages: builder.mutation({
      query: (data) => ({
        url: `/upload-editor-foto`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Modul"],
    }),
    GetImages: builder.mutation({
      query: (data) => ({
        url: `/get-editor-foto`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Modul"],
    }),
  }),
});

export const { useEditorImagesMutation, useGetImagesMutation } = editorImages;
